const news = [
  {
    id: 1,
    date: 'September 13',
    supTitle: 'Cirrus news',
    title: 'Self-service as a competitive advantage',
    image: '/images/temp/blog/news-1.jpg',
  },
  {
    id: 2,
    date: 'September 13',
    supTitle: 'Cirrus news',
    title: 'Reopening your restaurant: what you need to know',
    image: '/images/temp/blog/news-2.jpg',
  },
  {
    id: 3,
    date: 'September 13',
    supTitle: 'Cirrus news',
    title: 'Meeting their omnichannel payment demands, and engaging with them',
    image: '/images/temp/blog/news-3.jpg',
  },
  {
    id: 4,
    date: 'September 13',
    supTitle: 'Cirrus news',
    title: 'Self-service as a competitive advantage',
    image: '/images/temp/blog/news-4.jpg',
  },
  {
    id: 5,
    date: 'September 13',
    supTitle: 'Cirrus news',
    title: 'Meeting their omnichannel payment demands, and engaging with them',
    image: '/images/temp/blog/news-5.jpg',
  },
];

export default news;
